<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

const open = ref(false)

const debouncedClose = useDebounceFn(() => {
  open.value = false
}, 200)
</script>

<template>
  <UPopover
    class="hidden items-baseline lg:flex"
    :ui="{
      width: 'w-full left-0 !-ml-[8px] rounded-0',
      shadow: '',
      ring: '',
      rounded: '',
    }"
    mode="hover"
    :close-delay="300"
    @pointerenter="open = true"
    @pointerleave="debouncedClose()"
  >
    <NuxtLink
      :to="localePath({ name: 'products' })"
      class="no-underline transition duration-300"
    >
      <div class="group font-bold transition duration-300 xl:text-lg">
        <div class="flex items-center">
          <span class="whitespace-nowrap">
            {{ t('base.products.products') }}
          </span>
          <IconDropdownArrow class="ml-1" :class="{ 'rotate-180': open }" />
        </div>
        <span
          class="-mt-1 block h-[1px] max-w-0 bg-black transition-all duration-500 group-hover:max-w-full"
          :class="{
            '!max-w-full': $route.path.includes(
              localePath({ name: 'products' })
            ),
          }"
        />
      </div>
    </NuxtLink>
    <template #panel="{ close }">
      <UiProductCategoryMenu @close="close()" />
    </template>
  </UPopover>
</template>

<style scoped></style>
